export const Chip = {
    MuiChip: {
      styleOverrides: {
        label: {
          whiteSpace: 'inherit',
        },
      }
    },
};
